import { colors, fontSizes } from '../../../../Components/consts'
import { styled } from '@mui/system'

export const WKHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: `linear-gradient(to top left, ${colors.gray.gray20}, ${colors.lightestGrey})`,
  borderRadius: `12px 12px 0 0 `,
  paddingRight: theme.spacing(2),
  marginTop: theme.spacing(1),
  minHeight: 40,
  '& .gameInfo': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& .gameWeek': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      minHeight: 40,
      minWidth: 30,
      background: colors.black,
      borderRadius: '5px 0 0 0',
      padding: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    '& .weekendInfoCon': {
      display: 'flex',
      flexDirection: 'column',
      margin: theme.spacing(3),
      '& h2': {
        fontWeight: 700,
        fontSize: fontSizes.medium,
        margin: theme.spacing(0.5, 0),
        [theme.breakpoints.down('sm')]: {
          fontSize: fontSizes.small,
        },
      },
      '& p': {
        fontWeight: 500,
        margin: theme.spacing(1, 2),
        [theme.breakpoints.down('sm')]: {
          fontSize: fontSizes.xSmall,
          margin: theme.spacing(0.5),
        },
      },
    },
  },
}))

export const WeekBoxCon = styled('div')(({ theme }) => ({
  margin: theme.spacing(0, 0, 4, 0),
}))

export const DayGamesSection = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  margin: theme.spacing(2, 0, 4),
  '& .headerRow': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    margin: theme.spacing(1),
    '& .tixIcon': {
      marginRight: theme.spacing(3),
    },
    
  },
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2, 0, 2),
  },
}))

type CalloutProps = {
  border?: boolean
  leftBorderColor?: string
}

export const CalloutCon = styled('div')<CalloutProps>(
  ({ theme, border, leftBorderColor }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    '& .callout': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      background: colors.lightestGrey,
      borderRadius: 12,
      borderRight: border ? `1px solid ${colors.lightestGrey}` : 'none',
      borderTop: border ? `1px solid ${colors.lightestGrey}` : 'none',
      borderBottom: border ? `1px solid ${colors.lightestGrey}` : 'none',
      borderLeft: `8px solid ${leftBorderColor || colors.gray.gray40}`,
      margin: theme.spacing(2, 1),
      padding: theme.spacing(0, 1),
      '& .calloutOptionRow': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        margin: theme.spacing(0, 1),
        padding: theme.spacing(1),
        borderTop: `3px solid ${colors.lightestGrey}`,
        '&:first-of-type': {
          borderTop: 0,
        },
        [theme.breakpoints.down('sm')]: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          margin: theme.spacing(0, 0.5),
          padding: theme.spacing(1, 0),
        },
      },
    },
  })
)
export const TicketInfoCol = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  '& .title': {
    fontWeight: 500,
    fontSize: fontSizes.semiLarge,
    margin: theme.spacing(0.5, 1),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.medium,
      margin: '0 2px',
    },
  },
  '& .description': {
    fontWeight: 400,
    fontSize: fontSizes.medium,
    margin: '1px 15px',
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      textAlign: 'center',
      margin: '5px 2px',
    },
  },
}))

export const TicketActionCol = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}))

export const TicketOptionRow = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: theme.spacing(0, 3),
  padding: theme.spacing(1, 3),
  borderTop: `3px solid ${colors.lightestGrey}`,
  '&:first-of-type': {
    borderTop: 0,
  },
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(0, 0.5),
    padding: theme.spacing(1, 0),
  },
}))

export const SpecialWk = styled('div')(({ theme }) => ({
  background: `linear-gradient(to bottom right, ${colors.yellow}, rgb(253, 250, 225))`,
  borderRadius: `0 0 12px 12px`,
  padding: theme.spacing(2, 1),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1),
  },
  '& .hcTitle': {
    color: colors.black,
    fontSize: fontSizes.large,
    fontWeight: 700,
    textAlign: 'center',
    margin: theme.spacing(0),
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.medium,
    },
  },
}))

export const ScheduleTableCon = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',

  '& th': {
    fontSize: fontSizes.xSmall,
    color: colors.text,
    fontWeight: 'normal',
    textTransform: 'uppercase',
    height: theme.spacing(3),

    '&:first-of-type': {
      textAlign: 'left',
    },
  },

  // Table body styles
  '& tbody': {
    '& tr': {
      borderTop: `1px solid ${colors.lightestGrey}`,

      '&:first-of-type': {
        borderTop: 0,
      },
    },

    '& td': {
      fontSize: fontSizes.medium,
      padding: theme.spacing(1.5, 0),
      color: colors.text,
      minHeight: 60,
      textAlign: 'left',
      fontWeight: 500,
      transition: 'all 0.2s ease',
      verticalAlign: 'middle',

      // Empty cell handling
      '&:empty::after': {
        content: '""',
        display: 'inline-block',
        minWidth: '30px',
        minHeight: '1em',
      },

      '&:first-of-type': {
        width: 60,
        minWidth: 60,
        maxWidth: 60,
        textAlign: 'left',
        fontSize: fontSizes.small,
        fontWeight: 600,
        paddingLeft: theme.spacing(2),
      },

      '&:nth-of-type(2)': {
        width: '70%',
        textAlign: 'left',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
      },

      '&:nth-of-type(3)': {
        width: '20%',
        minWidth: 50,
        textAlign: 'center',
      },

      '&:last-of-type': {
        width: '15%',
        minWidth: 40,
        textAlign: 'center',
        whiteSpace: 'nowrap',
      },

      '& a': {
        color: colors.text,
        textDecoration: 'none',
      },

      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: fontSizes.small,
        padding: theme.spacing(1, 1.2),

        '&:first-of-type': {
          width: 50,
          minWidth: 50,
          maxWidth: 50,
        },
      },

      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0.8, 0.5),
        fontSize: fontSizes.xSmall,

        '&:first-of-type': {
          fontSize: fontSizes.xSmall,
          width: 40,
          minWidth: 40,
          maxWidth: 40,
        },

        '&:nth-of-type(2)': {
          width: '55%',
          minWidth: 40,
        },

        '&:nth-of-type(3)': {
          width: 35,
          minWidth: 35,
          maxWidth: 35,
        },

        '&:last-of-type': {
          width: 40,
          minWidth: 40,
          maxWidth: 40,
        },
      },
    },
  },

  '& tfoot td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textAlign: 'center',
    fontWeight: 'normal',
    fontSize: fontSizes.xSmall,
  },
}))

export const DefaultTableCol = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2),
  width: '100%',
}))

export const TeamsTableCol = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  '& .innerCol': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    '& .live': {
      fontSize: '0.8rem',
      fontWeight: 700,
      color: colors.green,
      marginTop: 3,
    },
    '& .results': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      '& .resultItem': {
        width: '100%',
        fontSize: fontSizes.medium,
        color: colors.text,
        fontWeight: 800,
        margin: theme.spacing(0, 2),
        [theme.breakpoints.down('md')]: {
          margin: theme.spacing(0, 1),
        },
      },
      '& .vs': {
        width: 20,
        textAlign: 'center',
        fontSize: 12,
        margin: 10,
        color: colors.text,
        fontWeight: 600,
        [theme.breakpoints.down('md')]: {
          fontSize: 10,
          margin: 5,
        },
      },
    },
    '& status': {
      fontSize: 12,
      margin: 2,
      color: colors.green,
      textAlign: 'center',
      fontWeight: 600,
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: 10,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0.5, 1),
        fontSize: 8,
      },
    },
  },
}))

export const TeamItemCon = styled('div')<{ justify: 'left' | 'right' }>(
  ({ theme, justify }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: justify,
    flexWrap: 'wrap',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexWrap: justify === 'left' ? 'wrap' : 'wrap-reverse',
    },
    '& > div': {
      margin: theme.spacing(0, 1),
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0, 0.5),
      },
      '& img': {
        height: 35,
        [theme.breakpoints.between('sm', 'lg')]: {
          height: 30,
        },
        [theme.breakpoints.down('sm')]: {
          height: 20,
        },
      },
    },
    '& a': {
      textDecoration: 'none',
      cursor: 'pointer',
    },
  })
)

export const TmName = styled('p')<{ justify?: 'left' | 'right' | 'center' }>(
  ({ theme, justify }) => ({
    fontSize: fontSizes.medium,
    margin: 5,
    color: colors.text,
    textAlign: justify ?? 'center',
    fontWeight: 600,
    cursor: 'pointer',
    [theme.breakpoints.between('sm', 'lg')]: {
      fontSize: fontSizes.small,
      maxWidth: 85,
    },
    [theme.breakpoints.down('sm')]: {
      margin: 3,
      fontSize: fontSizes.xSmall,
      maxWidth: 65,
    },
  })
)

export const DescriptionName = styled('p')<{ justify?: 'left' | 'right' | 'center' }>(
  ({ theme, justify }) => ({
    fontSize: fontSizes.medium,
    margin: 5,
    color: colors.text,
    textAlign: justify ?? 'center',
    fontWeight: 600,
    cursor: 'pointer',
    [theme.breakpoints.between('sm', 'lg')]: {
      fontSize: fontSizes.small,
    },
    [theme.breakpoints.down('sm')]: {
      margin: 3,
      fontSize: fontSizes.xSmall,
    },
  })
)

export const ScoreItem = styled('h3')(({ theme }) => ({
  fontSize: fontSizes.medium,
  color: colors.text,
  fontWeight: 800,
  margin: theme.spacing(0, 1.5),
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.small,
    margin: theme.spacing(0, 1),
  },
}))

export const BroadcastCon = styled('td')(({ theme }) => ({
  '& a': {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    cursor: 'pointer',
    textDecoration: 'none',
    '& .broadcaster': {
      display: 'inline-block',
      width: 60,
      margin: '2px 3px 2px 2px',
      [theme.breakpoints.down('sm')]: {
        width: 30,
      },
      [theme.breakpoints.down('xs')]: {
        width: 25,
      },
    },
  },
}))

export const AcademyCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& img': {
    height: 40,
  },
  '& .academyLink': {
    textDecoration: 'none',
    textAlign: 'center',
    margin: theme.spacing(1),
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    border: `solid 1px ${colors.helperText}`,
    fontSize: fontSizes.medium,
    fontWeight: 'bold',
    width: 140,
    color: colors.text,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    '&:hover': {
      background: colors.lightestGrey,
    },
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      fontSize: fontSizes.medium,
      padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
      width: 160,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      margin: theme.spacing(1),
      padding: theme.spacing(1, 2),
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: fontSizes.small,
      margin: theme.spacing(1, 0.25),
      padding: theme.spacing(1, 2),
      width: '100%',
    },
  },
}))

export const AcademyLink = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  textAlign: 'center',
  margin: theme.spacing(1),
  padding: theme.spacing(1, 2),
  borderRadius: theme.spacing(1),
  border: `solid 1px ${colors.helperText}`,
  fontSize: fontSizes.medium,
  fontWeight: 'bold',
  width: 140,
  color: colors.text,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    background: colors.lightestGrey,
  },
  '&:focus': {
    outline: 'none',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: fontSizes.medium,
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    width: 160,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
    margin: theme.spacing(1),
    padding: theme.spacing(1, 2),
    width: '100%',
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: fontSizes.small,
    margin: theme.spacing(1, 0.25),
    padding: theme.spacing(1, 2),
    width: '100%',
  },
}))

export const NoDateCalloutCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(16, 4),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(12, 2),
  },
}))

export const SchedActionCon = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  '& .blackOutlineBtn': {
    display: 'inline-block',
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(1),
    border: `solid 1px ${colors.text}`,
    fontSize: '1rem',
    fontWeight: 'bold',
    color: colors.text,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#333',
    },
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      fontSize: '1rem',
      padding: theme.spacing(0.5, 1),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
      padding: theme.spacing(0.5, 1),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7rem',
      padding: theme.spacing(0.25, 0.5),
    },
  },
  '& .yellowBtn': {
    display: 'inline-block',
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(1),
    border: 'none',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: colors.black,
    backgroundColor: colors.yellow,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: colors.blue,
      color: colors.white,
    },
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      padding: theme.spacing(0.5, 1),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9rem',
      padding: theme.spacing(0.5),
    },
  },
}))

export const TimeCol = styled('td')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: fontSizes.medium,
  padding: theme.spacing(1.5, 0),
  color: colors.text,
  minHeight: 60,
  textAlign: 'left',
  fontWeight: 500,
  transition: 'all 0.2s ease',
  verticalAlign: 'middle',
  '& span': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& img': {
    height: 20,
  },
}))
